// src/components/layout/Footer/Footer.jsx

import React from "react";
import event from "../../../assets/site-images/eventfullsunday.png";
import { Field, Form, Formik } from "formik";
import { IoPersonCircle } from "react-icons/io5";
import * as Yup from "yup";
import { MdOutlineMail } from "react-icons/md";
import { FaFacebook, FaInstagram, FaWhatsapp, FaGooglePlay, FaApple } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { subscription } from "../../../redux/auth/action/SubscriptionActions";

const Footer = () => {
  const dispatch = useDispatch();

  return (
    <footer className="w-full bg-white shadow-lg border-t border-gray-100">
      {/* Main content container */}
      <div className="max-w-[1400px] mx-auto px-6 py-10">
        {/* Upper section with grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Column 1: Branding and Company Info */}
          <div className="flex flex-col space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src={event}
                alt="Eventfull Sunday"
                className="h-12 w-auto"
              />
              <div>
                <p className="text-xl font-bold text-[#004B95]">
                  Eventfull Sunday
                </p>
                <p className="text-xs text-gray-600">Organizer Portal</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Your comprehensive platform for creating, managing, and promoting community events. 
              Tailored specifically for event organizers to streamline your event management process.
            </p>
            <div className="pt-2">
              <p className="text-sm text-gray-500 font-medium">Follow us</p>
              <div className="flex space-x-4 mt-2">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#004B95] transition-colors">
                  <FaFacebook size={22} />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#004B95] transition-colors">
                  <FaInstagram size={22} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#004B95] transition-colors">
                  <BsTwitterX size={20} />
                </a>
                <a href="https://whatsapp.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#004B95] transition-colors">
                  <FaWhatsapp size={22} />
                </a>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col space-y-4">
            <h3 className="text-base font-semibold text-gray-800 border-b border-gray-200 pb-2">Quick Links</h3>
            <div className="flex flex-col space-y-3">
              <a
                href="https://events.eventfullsunday.co.uk/about-us/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#004B95] transition-colors text-sm"
              >About us</a>
              <a
                href="https://events.eventfullsunday.co.uk/terms-conditions/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#004B95] transition-colors text-sm"
              >Terms and conditions</a>
              <a
                href="https://events.eventfullsunday.co.uk/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#004B95] transition-colors text-sm"
              >Privacy Policy</a>
              <a
                href="https://events.eventfullsunday.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#004B95] transition-colors text-sm"
              >Contact us</a>
            </div>
          </div>

          {/* Column 3: Mobile Apps */}
          <div className="flex flex-col space-y-4">
            <h3 className="text-base font-semibold text-gray-800 border-b border-gray-200 pb-2">Mobile Apps</h3>
            <p className="text-sm text-gray-600">Download our mobile app to manage events on the go</p>
            <div className="flex space-x-4 mt-2">
              <a 
                href="https://play.google.com/store/apps/details?id=com.cubeqtec.eventsfullsundays&pcampaignid=web_share" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-black text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-gray-800 transition-colors text-xs"
              >
                <FaGooglePlay size={18} />
                <div>
                  <div className="text-xs opacity-80">GET IT ON</div>
                  <div className="font-medium">Google Play</div>
                </div>
              </a>
              <a 
                href="https://apple.com/app-store" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-black text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-gray-800 transition-colors text-xs"
              >
                <FaApple size={22} />
                <div>
                  <div className="text-xs opacity-80">Download on the</div>
                  <div className="font-medium">App Store</div>
                </div>
              </a>
            </div>
          </div>

          {/* Column 4: Newsletter */}
          <div className="flex flex-col space-y-4">
            <h3 className="text-base font-semibold text-gray-800 pb-2">Newsletter</h3>
            <p className="text-sm text-gray-600">Get updates and event management tips</p>
            
            <Formik
              initialValues={{
                full_name: "",
                email: ""
              }}
              validate={(values) => {
                const errors = {};
                if (!values.full_name) errors.full_name = "Required";
                if (!values.email) errors.email = "Required";
                else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                  errors.email = "Invalid email address";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                // Log what form is submitting
                console.log("Form submitting:", values);
                
                dispatch(subscription({
                  full_name: values.full_name.trim(),
                  email: values.email.trim()
                }))
                .then(success => {
                  if (success) resetForm();
                  setSubmitting(false);
                })
                .catch(() => {
                  setSubmitting(false);
                });
              }}
            >
              {({ isSubmitting, errors, touched, handleSubmit }) => (
                <Form className="space-y-3" onSubmit={(e) => {
                  e.preventDefault(); // Explicitly prevent default form behavior
                  handleSubmit(e);
                }}>
                  <div>
                    <Field
                      type="text"
                      name="full_name"
                      placeholder="Full Name"
                      className={`w-full p-2 border rounded ${
                        errors.full_name && touched.full_name ? "border-red-500" : ""
                      }`}
                    />
                    {errors.full_name && touched.full_name && (
                      <div className="text-red-500 text-xs mt-1">{errors.full_name}</div>
                    )}
                  </div>

                  <div>
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      className={`w-full p-2 border rounded ${
                        errors.email && touched.email ? "border-red-500" : ""
                      }`}
                    />
                    {errors.email && touched.email && (
                      <div className="text-red-500 text-xs mt-1">{errors.email}</div>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-[#004B95] text-white px-4 py-2 rounded w-full"
                  >
                    {isSubmitting ? "Subscribing..." : "Subscribe"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 my-6"></div>
        
        {/* Bottom section with copyright and company info */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-600">
            &copy; 2024-2025 Eventfull Sundays. All rights reserved.
          </div>
          <div className="text-sm text-gray-600 font-medium">
            This platform is a product of <span className="text-[#004B95]">Cubeq Analytica Ltd</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
